module.exports = __webpack_public_path__ + "img/act-of-emotion-process-2-mobile.2bb0669f.jpg";